import { formatWithCommas } from "../../../utils/helper";

/** Mirrors the backend TemplateTextFieldsCannotExceedMaxLengthOnCreateOrUpdate limit. */
export const TEMPLATE_TEXT_MAX_LENGTH = 250;

export const templateTextLimitMessage = (label: string) =>
  `${label} cannot exceed ${TEMPLATE_TEXT_MAX_LENGTH} characters`;

export const exceedsTemplateTextLimit = (value?: string | null) =>
  (value?.length ?? 0) > TEMPLATE_TEXT_MAX_LENGTH;

/** Same cap and wording as the shared currency inputs (CurrencyInput / Inputs.tsx). */
export const TEMPLATE_AMOUNT_MAX = 99999999.99;

export const templateAmountLimitMessage = () =>
  `Amount cannot exceed $${formatWithCommas(TEMPLATE_AMOUNT_MAX)}`;

export const exceedsTemplateAmountLimit = (value?: string | number | null) => {
  const numeric = parseFloat(String(value ?? "").replace(/,/g, ""));
  return !isNaN(numeric) && numeric > TEMPLATE_AMOUNT_MAX;
};
